module.exports = __webpack_public_path__ + "static/media/sales-stream-ticket.418d3dbc.svg";